var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shangwushuju-layer"},[_c('caseheader',{on:{"nextStep":_vm.nextStep}}),_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.showiframe),expression:"showiframe"}],staticStyle:{"width":"100%","height":"calc(99.8% - 60px)","border":"0"},attrs:{"id":"myIframe","src":_vm.dygptUrl + _vm.version}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }